module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/metal-detector/display2.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/metal-detector/display2.png
// module id = 590
// module chunks = 0